declare var Swiper: any;

declare var Sentry: {
  captureException: Function,
};

const $window = $(window);
const $photoSlider = $('.js-photo-slider');
let $prevArrow: JQuery<HTMLElement>;
let $nextArrow: JQuery<HTMLElement>;

let swiper: {
  params: { slidesPerView: string },
  slideNext: Function,
  slidePrev: Function,
  update: Function,
  slides: [HTMLElement],
  activeIndex: number,
};
let lastHeight = 0;
let windowWidth: number;

const ARROW_BUFFER = 65;

const photoSlider = {
  initialize() {
    if (!$photoSlider.length) {
      return;
    }

    if (typeof Swiper === 'undefined') {
      throw new Error('You should add Swiper before using the card slider');
    }

    this.getArrows();

    this.createSlider();
    this.recalculateSlides();
    this.calculateArrowPositions();

    // This fixes the CLS, I don't know why...
    setTimeout(
      () => {
        this.showSlider();
      },
      10,
    );

    $window.trigger('recalculate:size');

    $window.on('resize', () => {
      this.recalculateSlides();
      this.calculateArrowPositions();
    });
  },

  showSlider() {
    $photoSlider.css('opacity', 1);
    $photoSlider.css('visibility', 'visible');
  },

  getArrows() {
    $prevArrow = $photoSlider.find('.js-swiper-prev');
    $nextArrow = $photoSlider.find('.js-swiper-next');
  },

  createSlider() {
    swiper = new Swiper($photoSlider.find('.swiper-container')[0], {
      // effect: 'coverflow',
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 5,
      loop: true,
      navigation: {
        nextEl: $nextArrow[0],
        prevEl: $prevArrow[0],
      },
      on: {
        slideChangeTransitionEnd: () => {
          this.calculateArrowPositions();
        },
      },
    });

    $photoSlider.addClass('is-initialized');
  },

  lazySliderImages() {
    return $photoSlider.find('[data-src]').toArray();
  },

  loadImage(image) {
    return new Promise((resolve, reject) => {
      const dataSource = image.getAttribute('data-src');
      const imageLoader = new Image();
      imageLoader.onload = () => {
        image.src = dataSource;
        resolve(null);
      };
      imageLoader.onerror = reject;
      imageLoader.src = dataSource;
    });
  },

  getSlidesHeight() {
    const windowWidth = $window.width();

    let slides = 2;

    if (windowWidth > 1200) {
      slides = 3.4;
    } else if (windowWidth > 480) {
      slides = 2.85;
    }

    return windowWidth / slides;
  },

  recalculateSlides() {
    const slideHeight = this.getSlidesHeight();

    windowWidth = $window.width();

    if (lastHeight === slideHeight) {
      return;
    }

    lastHeight = slideHeight;

    $photoSlider.css('height', slideHeight);

    $photoSlider.find('img').toArray().forEach((img) => {
      const width = parseInt(img.getAttribute('width'), 10);
      const height = parseInt(img.getAttribute('height'), 10);
      const ratio = height / width;
      const wantedWidth = slideHeight / ratio;

      $(img).parents('.swiper-slide').css('width', wantedWidth);
    });

    swiper.update();
  },

  calculateArrowPositions() {
    if (typeof swiper === 'undefined') {
      return;
    }

    const currentSlide = swiper.slides[swiper.activeIndex];

    if (typeof currentSlide === 'undefined') {
      return;
    }

    const offsetLeft = $(currentSlide).offset().left;
    const slideWidth = $(currentSlide).width();

    let arrowLeft = offsetLeft - ARROW_BUFFER;
    let arrowRight = windowWidth - (offsetLeft + slideWidth) - ARROW_BUFFER;

    if (arrowLeft < 10) {
      arrowLeft = 10;
    }

    if (arrowRight < 10) {
      arrowRight = 10;
    }

    $prevArrow.css('left', arrowLeft).css('opacity', 1);
    $nextArrow.css('right', arrowRight).css('opacity', 1);
  },
};

export default photoSlider;
